import React, { useEffect, useState } from "react";
import url from "../../services/url";
import { If } from "react-condition";
import { useHistory, useLocation } from "react-router-dom";
import axios from "../../services/axios";
import Loginimg from "../../images/Maxicus_logo.png";

function ConsultantLogin() {
  const [alert, setAlert] = useState("");
  const history = useHistory();
  const locationUrl = useLocation();
  const searchParams = new URLSearchParams(locationUrl.search);
  const continueTo = searchParams.get("continueTo" || "");

  const [email, setEmail] = useState("");
  const [emailErr, setEmailErr] = useState("");
  const [password, setPassword] = useState("");
  const [authErr, setAuthErr] = useState("");
  const [loginErr, setLoginErr] = useState("");
  const [otp, setOtp] = useState("");
  const [otpErr, setOtpErr] = useState("");
  const [toggle, setToggle] = useState(false);

  // Initialize a boolean state
  const [passwordShown, setPasswordShown] = useState(false);

  const handleEmail = (e) => {
    setEmailErr("");
    setAuthErr("");
    setLoginErr("");
    const emailValidate = /\S+@\S+\.\S+/;
    if (!e.target.value.match(emailValidate)) {
      setEmailErr("invalid email format");
    }
    setEmail(e.target.value);
  };

  const handlePassword = (e) => {
    setAuthErr("");
    setLoginErr("");
    setPassword(e.target.value);
  };

  // Password toggle handler
  const togglePassword = () => {
    setPasswordShown(!passwordShown);
  };

  //   Timer
  const [count, setCount] = useState(59);
  const [isRunning, setIsRunning] = useState(false);
  const [reSendStatus, setReSendStatus] = useState(false);

  useEffect(() => {
    let interval;
    if (isRunning) {
      interval = setInterval(() => {
        if (count === 0) {
          setIsRunning(false);
          setReSendStatus(true);
          return;
        } else {
          setCount((count) => count - 1);
        }
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [isRunning, count]);

  function onClickLogin(event) {
    setAuthErr("");
    event.preventDefault();
    axios
      .post("/registerConsultant/login", {
        email: email,
        password: password,
      })
      .then((res) => {
        setToggle(res?.data?.verified);
        setIsRunning(true);
      })
      .catch((err) => {
        setAuthErr(
          err.response.data?.errorMsg &&
            60 - Math.floor(err.response.data?.errorMsg)
        );
        setLoginErr(err.response.data.error);
      });
  }

  async function resendOtp(event) {
    setOtp("");
    setAuthErr("");
    event.preventDefault();
    axios
      .post("/registerConsultant/login", {
        email: email,
        password: password,
      })
      .then((res) => {
        setToggle(res?.data?.verified);
        setReSendStatus(false);
        setIsRunning(true);
        setOtpErr("");
        setCount(59);
        setAuthErr("");
      })
      .catch((err) => {
        setAuthErr(err.response.data.error);
      });
  }

  const handleOtp = (e) => {
    setOtpErr("");
    var reg = new RegExp("^[0-9]*$");
    if (!reg.test(e.target.value)) {
      setOtpErr("Please enter valid OTP");
    } else if (e.target.value.length > 6) {
      setOtpErr("Please enter valid OTP");
    } else {
      setOtpErr("");
    }
    setOtp(e.target.value);
  };

  const verifyOtp = (e) => {
    e.preventDefault();
    axios
      .post("/registerConsultant/verifyotp", {
        otp: otp,
        email: email,
        password: password,
      })
      .then((res) => {
        const response = res.data;
        localStorage.clear();
        localStorage.setItem("consultant.token", response.token);
        localStorage.setItem("consultant.id", response._id);
        localStorage.setItem("consultant.name", response.name);
        localStorage.setItem("consultant.email", response.email);
        localStorage.setItem("consultant.role", response.role);

        if (response.role !== "consultant") {
          localStorage.clear();
          return setAuthErr("Invalid User");
        }

        if (continueTo) {
          return history.push(continueTo);
        }

        history.push("/consultantdashboard");
      })
      .catch((err) => {
        setOtpErr(err.response.data.error);
      });
  };

  //Forgotten Password function
  const ForgetPassword = () => {
    history.push("/userresetpassword");
  };

  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-xl-10 col-lg-12 col-md-9">
          <div className="card o-hidden border-0 shadow-lg my-5">
            <div className="card-body p-0">
              <div className="row">
                <div className="col-lg-6 d-none d-lg-block bg-login-image"></div>
                <div className="col-lg-6">
                  <div className="p-5">
                    <div className="text-center">
                      <img src={Loginimg} alt="Login" className="mb-1" />
                      <h1 className="h4 text-gray-900 mb-4">
                        Consultant Login
                        {/* {toggle && <span style={{color: " #fa8006"}} className="ml-5">{count}</span>} */}
                      </h1>
                    </div>
                    <form className="user">
                      <div className="form-group">
                        <input
                          onChange={handleEmail}
                          name="email"
                          value={email}
                          type="text"
                          className="form-control rounded-input"
                          style={{ outline: "none" }}
                          placeholder="Enter Email"
                          disabled={toggle}
                        />
                        {emailErr && (
                          <div
                            className="text-danger"
                            style={{ marginTop: 5 + "px" }}
                          >
                            {emailErr}
                          </div>
                        )}
                      </div>
                      <div className="form-group position-relative ">
                        <input
                          className="form-control rounded-input"
                          style={{ outline: "none" }}
                          // type="password"
                          onChange={handlePassword}
                          name="password"
                          value={password}
                          disabled={toggle}
                          type={passwordShown ? "text" : "password"}
                          // className="form-control form-control-user"
                          id="password"
                          placeholder="Enter Password..."
                        />
                        <span
                          className="inputPassword"
                          onClick={togglePassword}
                        >
                          {passwordShown ? (
                            <i class="fas fa-eye"></i>
                          ) : (
                            <i class="fas fa-eye-slash"></i>
                          )}
                        </span>

                        {authErr && (
                          <div
                            className="text-danger ml-3 mt-2"
                            style={{ marginTop: 5 + "px", fontSize: "20px" }}
                          >
                            {`To many request for last hour you can try after ${authErr} minutes`}
                          </div>
                        )}
                        {loginErr && (
                          <div
                            className="text-danger ml-3 mt-2"
                            style={{ marginTop: 5 + "px", fontSize: "20px" }}
                          >
                            {` ${loginErr}`}
                          </div>
                        )}
                      </div>

                      {!toggle && (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-evenly",
                            alignItems: "center",
                          }}
                        >
                          <span
                            style={{
                              cursor: "pointer",
                              color: "darkblue ",
                              fontSize: "15px",
                            }}
                            onClick={ForgetPassword}
                          >
                            Forget Password
                          </span>
                          <button
                            className="btn btn-primary btn-user "
                            onClick={onClickLogin}
                            style={{ width: "150px" }}
                          >
                            Login
                          </button>
                        </div>
                      )}
                    </form>

                    {toggle && (
                      <div className="form-group position-relative ">
                        <input
                          className="form-control rounded-input"
                          style={{ outline: "none" }}
                          type="text"
                          onChange={handleOtp}
                          name="otp"
                          value={otp}
                          id="otp"
                          placeholder="Enter otp..."
                        />
                        {otpErr && (
                          <div
                            className="text-danger ml-3 mt-2"
                            style={{ marginTop: 5 + "px", fontSize: "25px" }}
                          >
                            {otpErr}
                          </div>
                        )}{" "}
                        <br />
                        {toggle && !reSendStatus && (
                          <span
                            style={{
                              color: " #fa8006",
                              marginLeft: "5px",
                              fontSize: "15px",
                            }}
                          >
                            Resend OTP in {count}s
                          </span>
                        )}
                        <br />
                        {!reSendStatus ? (
                          <button
                            className="btn btn-primary btn-user mt-3 ml-5 "
                            onClick={verifyOtp}
                            style={{ width: "150px" }}
                          >
                            verify otp
                          </button>
                        ) : (
                          reSendStatus && (
                            <button
                              className="btn btn-primary btn-user mt-3 ml-5 "
                              onClick={resendOtp}
                              style={{ width: "150px" }}
                            >
                              resend otp
                            </button>
                          )
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ConsultantLogin;
